module.exports = {
  Login: () => import("./Login.vue"),
  Register: () => import("./components/Register.vue"),
  Form: () => import("./components/Form.vue"),
  Forgot: () => import("./components/Forgot.vue"),
  Reset: () => import("./components/Reset.vue")
};
